import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-tryher-review-grid';

const starIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" />
  </svg>`;

const reviewCard = ({ image, rating = 5, content }) => `
  <div data-attribute="tryher-review-grid__item" class="swiper-slide">
    <article class="tryher-review-grid__card">
      <img loading="lazy" class="tryher-review-grid__image" data-attribute="tryher-review-grid__image" src="${image}" alt="Customer before and after result" />
      <div data-attribute="tryher-review-grid__stars" data-value="${rating}" class="tryher-review-grid__stars">
        ${Array(5)
          .fill(starIcon)
          .join('')}
      </div>
      <div data-attribute="tryher-review-grid__content" class="tryher-review-grid__content">${content}</div>
    </article>
  </div>`;

const reviews = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/21/image-6a5f1addb1b6616f50faeb5d.webp?w=1000',
    content: `<p style="text-align:center;"><strong>“Not instant like TikTok says, but it does work.”</strong></p><p style="text-align:center;">I didn't see anything crazy day 1. Around day 3–5 I started noticing my lines looked softer. It's subtle but real. If you expect filters IRL you'll be disappointed. If you want actual improvement, this is solid.</p><p style="text-align:center;"><strong>@katie, 38</strong></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/21/image-6a5f1af8e942e14aa15e3ca6.webp?w=1000',
    content: `<p style="text-align:center;"><strong>“My under eyes look less hollow now.”</strong></p><p style="text-align:center;">That was my main problem. Dark + sunken. This didn't fix color completely, but it made everything look smoother and less empty. I actually like how I look without makeup now.</p><p style="text-align:center;"><strong>@nina, 27</strong></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/21/image-6a5f1b083d1676999a484187.webp?w=1000',
    content: `<p style="text-align:center;"><strong>“Week 1 my concealer stopped creasing. Week 2 I barely use it.”</strong></p><p style="text-align:center;">My under eyes were so hollow and dark, makeup would settle into every line. It looked worse with product on. This just made everything look smoother… like the skin filled back in a bit. Not dramatic overnight, but enough that I noticed fast.</p><p style="text-align:center;"><strong>@jessica, 29</strong></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/21/image-6a5f1b1ad107c94fc9ce66fa.webp?w=1000',
    content: `<p style="text-align:center;"><strong>“Feels like chapstick for your face… but it actually works.”</strong></p><p style="text-align:center;">Not gonna lie, first time I used it I was like ok this is just a balm. But after a few days my under eyes didn't look as tired. Skin looks more “alive” if that makes sense. I use it mostly at night.</p><p style="text-align:center;"><strong>@amanda, 34</strong></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/21/image-6a5f1b2990ce1f19c1d26dc3.webp?w=1000',
    content: `<p style="text-align:center;"><strong>“I stopped editing my smile lines out of pictures.”</strong></p><p style="text-align:center;">They were deep and super noticeable in photos. I've been using this morning and night and they're way softer now. Not gone, but I don't fixate on them anymore.</p><p style="text-align:center;"><strong>@rachel, 32</strong></p>`,
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/07/21/image-6a5f1b3881d70263adcb4104.webp?w=1000',
    content: `<p style="text-align:center;"><strong>“I look less tired even when I am.”</strong></p><p style="text-align:center;">My biggest issue was't wrinkles, it was that hollow, sunken look under my eyes. This made it look more filled and hydrated. Like I slept 8 hours when I didn't.</p><p style="text-align:center;"><strong>@lauren, 36</strong></p>`,
  },
];

const contentHtml = `
  <div
    data-attribute="tryher-review-grid"
    class="tryher-review-grid container"
    data-star-color="#FF6099"
    data-card-border-color="#1F1F1F"
    data-card-background-color="#FFFFFFF"
    data-card-text-color="#000000"
    data-arrow-color="#ff6099"
    data-container-full-width="true"
    data-breakpoint-mobile-slides="1" 
    data-breakpoint-tablet-slides="3" 
    data-breakpoint-desktop-slides="5"
    style="--star-color: #ff6099; --card-border-color: #1f1f1f; --card-background-color: #ffffff; --card-text-color: #000000; --arrow-color: #ff6099"
  >
    <div
      data-attribute="tryher-review-grid__header"
      class="tryher-review-grid__header"
    >
      <h2 style="text-align: center">
        <strong>From 'I look exhausted' → 'you look different'</strong>
      </h2>
      <p style="text-align: center">
        Based on 173,000 real reviews from women dealing with under-eye
        hollowness, lines, and tired-looking skin
      </p>
    </div>
    <div class="swiper tryher-review-grid-swiper-unique-id">
      <div data-attribute="tryher-review-grid__list" class="swiper-wrapper">
        ${reviews.map(reviewCard).join('')}
      </div>
    </div>
    <div class="tryher-review-grid__navigation" aria-label="Review navigation">
      <button
        type="button"
        class="arrow-left prev-unique-id"
        aria-label="Previous review"
      >
        <svg
          width="92"
          height="38"
          viewBox="0 0 92 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="transform: rotate(-180deg)"
        >
          <path
            d="M72.472 0L71.063 1.409L87.303 17.649H0V19.643H87.3L71.06 35.883L72.469 37.293L91.115 18.646L72.472 0Z"
            fill="black"
          ></path>
        </svg>
      </button>
      <button
        type="button"
        class="arrow-right next-unique-id"
        aria-label="Next review"
      >
        <svg
          width="92"
          height="38"
          viewBox="0 0 92 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M72.472 0L71.063 1.409L87.303 17.649H0V19.643H87.3L71.06 35.883L72.469 37.293L91.115 18.646L72.472 0Z"
            fill="black"
          ></path>
        </svg>
      </button>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#FFF7FC',
});
